export const useMockStore = defineStore('mock', {
  state: () => ({
    scenarios: [],
    isMinimized: false,
  }),

  getters: {
    isActive: (state) => state.scenarios.length > 0,

    allControls: (state) => state.scenarios.flatMap((scenario) =>
      scenario.controls.map((control) => ({ ...control, scenarioId: scenario.id })),
    ),
  },

  actions: {
    addScenario(scenario) {
      // Restore persisted control values if available
      const savedOverrides = this.getSavedOverrides(scenario.id);
      const controls = (scenario.controls || []).map((control) => ({
        ...control,
        value: savedOverrides[control.id] !== undefined ? savedOverrides[control.id] : control.value,
      }));

      this.scenarios.push({
        id: scenario.id,
        label: scenario.label,
        description: scenario.description || '',
        controls,
      });
      this.persist();
    },

    removeScenario(scenarioId) {
      this.scenarios = this.scenarios.filter((s) => s.id !== scenarioId);
      this.persist();
    },

    updateControl(scenarioId, controlId, value) {
      const scenario = this.scenarios.find((s) => s.id === scenarioId);
      if (!scenario) return;

      const control = scenario.controls.find((c) => c.id === controlId);
      if (!control) return;

      control.value = value;
      this.persist();
    },

    clear() {
      this.scenarios = [];
      this.isMinimized = false;
      sessionStorage.removeItem('mock-store');
    },

    toggleMinimized() {
      this.isMinimized = !this.isMinimized;
      this.persist();
    },

    persist() {
      const overrides = {};
      this.scenarios.forEach((scenario) => {
        overrides[scenario.id] = {};
        scenario.controls.forEach((control) => {
          overrides[scenario.id][control.id] = control.value;
        });
      });

      sessionStorage.setItem('mock-store', JSON.stringify({
        overrides,
        isMinimized: this.isMinimized,
      }));
    },

    hydrate() {
      const stored = sessionStorage.getItem('mock-store');
      if (!stored) return;

      try {
        const data = JSON.parse(stored);
        this.isMinimized = data.isMinimized || false;
        // Scenarios are NOT restored — they come from code.
        // Only isMinimized and overrides (read by addScenario) are restored.
      } catch {
        sessionStorage.removeItem('mock-store');
      }
    },

    getSavedOverrides(scenarioId) {
      const stored = sessionStorage.getItem('mock-store');
      if (!stored) return {};

      try {
        const data = JSON.parse(stored);
        return data.overrides?.[scenarioId] || {};
      } catch {
        return {};
      }
    },
  },
});
